// extracted by mini-css-extract-plugin
export default {"page":"aZ-z","cartModal":"bZ-z","checkout":"cZ-z","placeholder":"dZ-z","account":"eZ-z"};